export default __webpack_public_path__ + "assets/9e8d6fe5ecc56e0afb05ccca2aec4322.png";